import { ADD_REPORT, GET_ALL_REPORTS, GET_CONDITION_OPTIONS, GET_REPORT_BY_ID, CLEAR_REPORT } from './types';

export function getAllReports(payload) {
    return {
        type: GET_ALL_REPORTS,
        payload
    }
}

export function getConditionOptionArray(payload) {
    return {
        type: GET_CONDITION_OPTIONS,
        payload
    }
}

export function addReport(payload) {
    return {
        type: ADD_REPORT,
        payload
    }
}

export function getReportById(payload) {
    return {
        type: GET_REPORT_BY_ID, CLEAR_REPORT,
        payload
    }
}

export const clearReportState = () => {
    return {
      type: CLEAR_REPORT
    }
}